// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Selecteur de perimetre geographique acheteur (National / regions / departements). */

/* Banner "min 1 departement" (tentative de tout deselectionner). */
.perimetre-min-dept-error { margin-bottom: 1rem; }

.perimetre-selector {
  display: flex;
  flex-direction: column;
  gap: 1.25rem;
  font-size: 1.4rem;
  color: #374151;
}

.perimetre-selector.is-disabled {
  opacity: 0.6;
  pointer-events: none;
}

.perimetre-selector--loading,
.perimetre-selector--error {
  padding: 1rem;
  font-size: 1.3rem;
  color: #6b7280;
}

.perimetre-selector--error {
  color: #dc2626;
}

/* Choix du mode : National vs Zones precises */
.perimetre-modes {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 1rem;
}

.perimetre-mode {
  display: flex;
  align-items: center;
  gap: 1rem;
  padding: 1rem 1.25rem;
  border: 1px solid #e5e7eb;
  border-radius: 0.8rem;
  cursor: pointer;
  transition: border-color 0.15s, background 0.15s;
}

.perimetre-mode.is-active {
  border-color: #f97316;
  background: #fff7ed;
}

.perimetre-mode input[type="radio"] {
  flex-shrink: 0;
  margin: 0;
  accent-color: #f97316;
  width: 1.8rem;
  height: 1.8rem;
}

.perimetre-mode-text {
  display: flex;
  flex-direction: column;
  gap: 0.2rem;
  min-width: 0;
}

.perimetre-mode-titre {
  font-weight: 600;
  font-size: 1.4rem;
  color: #374151;
  line-height: 1.2;
}

.perimetre-mode-hint {
  font-size: 1.2rem;
  color: #6b7280;
  line-height: 1.2;
}

/* Zone de selection regions / departements */
.perimetre-zones {
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
}

.perimetre-empty {
  color: #b45309;
  font-style: italic;
  font-size: 1.3rem;
}

/* Texte d'aide sous le selecteur (section Perimetre geographique d'achat) */
.perimetre-section-hint {
  margin: 1rem 0 0 0;
  font-size: 1.2rem;
  color: #6b7280;
}

/* Bandeau National (toute la France selectionnee) */
.perimetre-national-banner {
  display: flex;
  flex-direction: column;
  gap: 0.4rem;
  padding: 1rem 1.25rem;
  background: #dcfce7;
  border: 1px solid #bbf7d0;
  border-radius: 0.8rem;
}

.perimetre-national-badge {
  font-size: 1.5rem;
  font-weight: 700;
  color: #166534;
}

.perimetre-quick-btn--national.is-active,
.perimetre-quick-btn--national:not(:disabled):hover {
  border-color: #f97316;
  color: #c2410c;
}

/* Resume de la selection courante : chips retirables */
.perimetre-selection {
  display: flex;
  flex-direction: column;
  gap: 0.6rem;
  padding: 1rem;
  background: #f9fafb;
  border: 1px solid #e5e7eb;
  border-radius: 0.8rem;
}

.perimetre-selection-tags {
  display: flex;
  flex-wrap: wrap;
  gap: 0.6rem;
}

.perimetre-tag {
  display: inline-flex;
  align-items: center;
  gap: 0.5rem;
  padding: 0.4rem 0.5rem 0.4rem 1rem;
  border-radius: 999px;
  font-size: 1.3rem;
  background: #fff;
  color: #374151;
  border: 1px solid #e5e7eb;
}

.perimetre-tag--region {
  background: #fff7ed;
  color: #c2410c;
  border-color: #fed7aa;
  font-weight: 600;
}

/* Pastille National : chip orange plein, comme une zone selectionnee */
.perimetre-tag--national {
  background: #f97316;
  color: #fff;
  border-color: #f97316;
}

.perimetre-tag--national .perimetre-tag-remove {
  background: rgba(255, 255, 255, 0.25);
}

.perimetre-tag--national .perimetre-tag-remove:hover {
  background: rgba(255, 255, 255, 0.4);
}

.perimetre-tag-remove {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 1.8rem;
  height: 1.8rem;
  border: none;
  border-radius: 50%;
  background: rgba(0, 0, 0, 0.06);
  color: inherit;
  font-size: 1.4rem;
  line-height: 1;
  cursor: pointer;
  padding: 0;
}

.perimetre-tag-remove:hover {
  background: rgba(0, 0, 0, 0.15);
}

.perimetre-selection-count {
  font-size: 1.2rem;
  color: #6b7280;
}

/* Barre d'outils : bascule a gauche, actions rapides a droite */
.perimetre-toolbar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 0.75rem;
}

.perimetre-quick-actions {
  display: flex;
  gap: 0.6rem;
}

.perimetre-quick-btn {
  padding: 0.5rem 1rem;
  border: 1px solid #e5e7eb;
  border-radius: 0.6rem;
  background: #fff;
  color: #374151;
  font-size: 1.3rem;
  font-weight: 600;
  cursor: pointer;
  transition: background 0.15s, border-color 0.15s;
}

.perimetre-quick-btn:hover:not(:disabled) {
  background: #f9fafb;
  border-color: #d1d5db;
}

.perimetre-quick-btn:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

/* Code (region / departement) en prefixe monospace dans la liste */
.perimetre-region-code {
  font-variant-numeric: tabular-nums;
  color: #111827;
  font-weight: 700;
}

/* Bascule Liste / Carte : composant partage ViewSwitch (styles deplaces dans ViewSwitch.css). */

/* Skeleton carte : styles deplaces dans PerimetreMapSkeleton.css (composant dedie). */

/* (Legacy) bouton repli/depli de l'arbre — conserve si reutilise ailleurs */
.perimetre-tree-toggle {
  display: inline-flex;
  align-items: center;
  gap: 0.6rem;
  align-self: flex-start;
  padding: 0.6rem 1rem;
  border: 1px solid #e5e7eb;
  border-radius: 0.6rem;
  background: #fff;
  color: #374151;
  font-size: 1.3rem;
  font-weight: 600;
  cursor: pointer;
}

.perimetre-tree-toggle:hover {
  background: #f9fafb;
  border-color: #d1d5db;
}

.perimetre-tree-toggle svg {
  transition: transform 0.2s;
}

.perimetre-tree-toggle.is-open svg {
  transform: rotate(180deg);
}

.perimetre-region-list {
  list-style: none;
  margin: 0;
  padding: 0;
  border: 1px solid #e5e7eb;
  border-radius: 0.8rem;
  overflow: hidden;
  max-height: 42rem;
  overflow-y: auto;
}

.perimetre-region {
  border-bottom: 1px solid #f3f4f6;
}

.perimetre-region:last-child {
  border-bottom: none;
}

.perimetre-region--full {
  background: #fff7ed;
}

.perimetre-region-row {
  display: flex;
  align-items: center;
  gap: 1rem;
  padding: 0.85rem 1rem;
}

.perimetre-region-check {
  display: flex;
  align-items: center;
  gap: 0.75rem;
  flex: 1 1;
  cursor: pointer;
}

.perimetre-region-check input[type="checkbox"] {
  width: 1.7rem;
  height: 1.7rem;
  accent-color: #f97316;
  flex-shrink: 0;
}

.perimetre-region-nom {
  font-weight: 600;
  color: #374151;
}

.perimetre-region-count {
  font-size: 1.2rem;
  color: #6b7280;
  white-space: nowrap;
}

.perimetre-region--full .perimetre-region-count,
.perimetre-region--partial .perimetre-region-count {
  color: #f97316;
  font-weight: 600;
}

.perimetre-region-toggle {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 2.8rem;
  height: 2.8rem;
  border: none;
  background: none;
  color: #6b7280;
  cursor: pointer;
  border-radius: 0.5rem;
  flex-shrink: 0;
}

.perimetre-region-toggle:hover {
  background: #f3f4f6;
  color: #374151;
}

.perimetre-region-toggle svg {
  transition: transform 0.2s;
}

.perimetre-region-toggle.is-open svg {
  transform: rotate(180deg);
}

/* Liste des departements (depliee) */
.perimetre-dept-list {
  list-style: none;
  margin: 0;
  padding: 0.25rem 1rem 0.85rem 3.5rem;
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(220px, 1fr));
  gap: 0.4rem 1.5rem;
  background: #fafafa;
}

.perimetre-dept-check {
  display: flex;
  align-items: center;
  gap: 0.6rem;
  cursor: pointer;
  padding: 0.3rem 0;
  font-size: 1.3rem;
}

.perimetre-dept-check input[type="checkbox"] {
  width: 1.5rem;
  height: 1.5rem;
  accent-color: #f97316;
  flex-shrink: 0;
}

.perimetre-dept-code {
  font-variant-numeric: tabular-nums;
  color: #111827;
  font-weight: 600;
}

.perimetre-dept-nom {
  color: #374151;
}
`, "",{"version":3,"sources":["webpack://./src/composants/PerimetreSelector/PerimetreSelector.css"],"names":[],"mappings":"AAAA,sFAAsF;;AAEtF,mEAAmE;AACnE,4BAA4B,mBAAmB,EAAE;;AAEjD;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,oBAAoB;AACtB;;AAEA;;EAEE,aAAa;EACb,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA,+CAA+C;AAC/C;EACE,aAAa;EACb,qCAAqC;EACrC,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,qBAAqB;EACrB,yBAAyB;EACzB,qBAAqB;EACrB,eAAe;EACf,gDAAgD;AAClD;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,SAAS;EACT,qBAAqB;EACrB,aAAa;EACb,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;EACX,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,gBAAgB;AAClB;;AAEA,6CAA6C;AAC7C;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA,4EAA4E;AAC5E;EACE,kBAAkB;EAClB,iBAAiB;EACjB,cAAc;AAChB;;AAEA,oDAAoD;AACpD;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;EACX,qBAAqB;EACrB,mBAAmB;EACnB,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;;EAEE,qBAAqB;EACrB,cAAc;AAChB;;AAEA,uDAAuD;AACvD;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,WAAW;AACb;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,WAAW;EACX,kCAAkC;EAClC,oBAAoB;EACpB,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA,uEAAuE;AACvE;EACE,mBAAmB;EACnB,WAAW;EACX,qBAAqB;AACvB;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,cAAc;EACd,YAAY;EACZ,kBAAkB;EAClB,+BAA+B;EAC/B,cAAc;EACd,iBAAiB;EACjB,cAAc;EACd,eAAe;EACf,UAAU;AACZ;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,iBAAiB;EACjB,cAAc;AAChB;;AAEA,gEAAgE;AAChE;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,eAAe;EACf,YAAY;AACd;;AAEA;EACE,aAAa;EACb,WAAW;AACb;;AAEA;EACE,oBAAoB;EACpB,yBAAyB;EACzB,qBAAqB;EACrB,gBAAgB;EAChB,cAAc;EACd,iBAAiB;EACjB,gBAAgB;EAChB,eAAe;EACf,gDAAgD;AAClD;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA,mEAAmE;AACnE;EACE,kCAAkC;EAClC,cAAc;EACd,gBAAgB;AAClB;;AAEA,gGAAgG;;AAEhG,sFAAsF;;AAEtF,4EAA4E;AAC5E;EACE,oBAAoB;EACpB,mBAAmB;EACnB,WAAW;EACX,sBAAsB;EACtB,oBAAoB;EACpB,yBAAyB;EACzB,qBAAqB;EACrB,gBAAgB;EAChB,cAAc;EACd,iBAAiB;EACjB,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,gBAAgB;EAChB,SAAS;EACT,UAAU;EACV,yBAAyB;EACzB,qBAAqB;EACrB,gBAAgB;EAChB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,SAAO;EACP,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,cAAc;EACd,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,mBAAmB;AACrB;;AAEA;;EAEE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,cAAc;EACd,YAAY;EACZ,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA,qCAAqC;AACrC;EACE,gBAAgB;EAChB,SAAS;EACT,oCAAoC;EACpC,aAAa;EACb,4DAA4D;EAC5D,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,eAAe;EACf,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,cAAc;EACd,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,kCAAkC;EAClC,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB","sourcesContent":["/* Selecteur de perimetre geographique acheteur (National / regions / departements). */\n\n/* Banner \"min 1 departement\" (tentative de tout deselectionner). */\n.perimetre-min-dept-error { margin-bottom: 1rem; }\n\n.perimetre-selector {\n  display: flex;\n  flex-direction: column;\n  gap: 1.25rem;\n  font-size: 1.4rem;\n  color: #374151;\n}\n\n.perimetre-selector.is-disabled {\n  opacity: 0.6;\n  pointer-events: none;\n}\n\n.perimetre-selector--loading,\n.perimetre-selector--error {\n  padding: 1rem;\n  font-size: 1.3rem;\n  color: #6b7280;\n}\n\n.perimetre-selector--error {\n  color: #dc2626;\n}\n\n/* Choix du mode : National vs Zones precises */\n.perimetre-modes {\n  display: grid;\n  grid-template-columns: repeat(2, 1fr);\n  gap: 1rem;\n}\n\n.perimetre-mode {\n  display: flex;\n  align-items: center;\n  gap: 1rem;\n  padding: 1rem 1.25rem;\n  border: 1px solid #e5e7eb;\n  border-radius: 0.8rem;\n  cursor: pointer;\n  transition: border-color 0.15s, background 0.15s;\n}\n\n.perimetre-mode.is-active {\n  border-color: #f97316;\n  background: #fff7ed;\n}\n\n.perimetre-mode input[type=\"radio\"] {\n  flex-shrink: 0;\n  margin: 0;\n  accent-color: #f97316;\n  width: 1.8rem;\n  height: 1.8rem;\n}\n\n.perimetre-mode-text {\n  display: flex;\n  flex-direction: column;\n  gap: 0.2rem;\n  min-width: 0;\n}\n\n.perimetre-mode-titre {\n  font-weight: 600;\n  font-size: 1.4rem;\n  color: #374151;\n  line-height: 1.2;\n}\n\n.perimetre-mode-hint {\n  font-size: 1.2rem;\n  color: #6b7280;\n  line-height: 1.2;\n}\n\n/* Zone de selection regions / departements */\n.perimetre-zones {\n  display: flex;\n  flex-direction: column;\n  gap: 0.75rem;\n}\n\n.perimetre-empty {\n  color: #b45309;\n  font-style: italic;\n  font-size: 1.3rem;\n}\n\n/* Texte d'aide sous le selecteur (section Perimetre geographique d'achat) */\n.perimetre-section-hint {\n  margin: 1rem 0 0 0;\n  font-size: 1.2rem;\n  color: #6b7280;\n}\n\n/* Bandeau National (toute la France selectionnee) */\n.perimetre-national-banner {\n  display: flex;\n  flex-direction: column;\n  gap: 0.4rem;\n  padding: 1rem 1.25rem;\n  background: #dcfce7;\n  border: 1px solid #bbf7d0;\n  border-radius: 0.8rem;\n}\n\n.perimetre-national-badge {\n  font-size: 1.5rem;\n  font-weight: 700;\n  color: #166534;\n}\n\n.perimetre-quick-btn--national.is-active,\n.perimetre-quick-btn--national:not(:disabled):hover {\n  border-color: #f97316;\n  color: #c2410c;\n}\n\n/* Resume de la selection courante : chips retirables */\n.perimetre-selection {\n  display: flex;\n  flex-direction: column;\n  gap: 0.6rem;\n  padding: 1rem;\n  background: #f9fafb;\n  border: 1px solid #e5e7eb;\n  border-radius: 0.8rem;\n}\n\n.perimetre-selection-tags {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 0.6rem;\n}\n\n.perimetre-tag {\n  display: inline-flex;\n  align-items: center;\n  gap: 0.5rem;\n  padding: 0.4rem 0.5rem 0.4rem 1rem;\n  border-radius: 999px;\n  font-size: 1.3rem;\n  background: #fff;\n  color: #374151;\n  border: 1px solid #e5e7eb;\n}\n\n.perimetre-tag--region {\n  background: #fff7ed;\n  color: #c2410c;\n  border-color: #fed7aa;\n  font-weight: 600;\n}\n\n/* Pastille National : chip orange plein, comme une zone selectionnee */\n.perimetre-tag--national {\n  background: #f97316;\n  color: #fff;\n  border-color: #f97316;\n}\n\n.perimetre-tag--national .perimetre-tag-remove {\n  background: rgba(255, 255, 255, 0.25);\n}\n\n.perimetre-tag--national .perimetre-tag-remove:hover {\n  background: rgba(255, 255, 255, 0.4);\n}\n\n.perimetre-tag-remove {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 1.8rem;\n  height: 1.8rem;\n  border: none;\n  border-radius: 50%;\n  background: rgba(0, 0, 0, 0.06);\n  color: inherit;\n  font-size: 1.4rem;\n  line-height: 1;\n  cursor: pointer;\n  padding: 0;\n}\n\n.perimetre-tag-remove:hover {\n  background: rgba(0, 0, 0, 0.15);\n}\n\n.perimetre-selection-count {\n  font-size: 1.2rem;\n  color: #6b7280;\n}\n\n/* Barre d'outils : bascule a gauche, actions rapides a droite */\n.perimetre-toolbar {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  flex-wrap: wrap;\n  gap: 0.75rem;\n}\n\n.perimetre-quick-actions {\n  display: flex;\n  gap: 0.6rem;\n}\n\n.perimetre-quick-btn {\n  padding: 0.5rem 1rem;\n  border: 1px solid #e5e7eb;\n  border-radius: 0.6rem;\n  background: #fff;\n  color: #374151;\n  font-size: 1.3rem;\n  font-weight: 600;\n  cursor: pointer;\n  transition: background 0.15s, border-color 0.15s;\n}\n\n.perimetre-quick-btn:hover:not(:disabled) {\n  background: #f9fafb;\n  border-color: #d1d5db;\n}\n\n.perimetre-quick-btn:disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n}\n\n/* Code (region / departement) en prefixe monospace dans la liste */\n.perimetre-region-code {\n  font-variant-numeric: tabular-nums;\n  color: #111827;\n  font-weight: 700;\n}\n\n/* Bascule Liste / Carte : composant partage ViewSwitch (styles deplaces dans ViewSwitch.css). */\n\n/* Skeleton carte : styles deplaces dans PerimetreMapSkeleton.css (composant dedie). */\n\n/* (Legacy) bouton repli/depli de l'arbre — conserve si reutilise ailleurs */\n.perimetre-tree-toggle {\n  display: inline-flex;\n  align-items: center;\n  gap: 0.6rem;\n  align-self: flex-start;\n  padding: 0.6rem 1rem;\n  border: 1px solid #e5e7eb;\n  border-radius: 0.6rem;\n  background: #fff;\n  color: #374151;\n  font-size: 1.3rem;\n  font-weight: 600;\n  cursor: pointer;\n}\n\n.perimetre-tree-toggle:hover {\n  background: #f9fafb;\n  border-color: #d1d5db;\n}\n\n.perimetre-tree-toggle svg {\n  transition: transform 0.2s;\n}\n\n.perimetre-tree-toggle.is-open svg {\n  transform: rotate(180deg);\n}\n\n.perimetre-region-list {\n  list-style: none;\n  margin: 0;\n  padding: 0;\n  border: 1px solid #e5e7eb;\n  border-radius: 0.8rem;\n  overflow: hidden;\n  max-height: 42rem;\n  overflow-y: auto;\n}\n\n.perimetre-region {\n  border-bottom: 1px solid #f3f4f6;\n}\n\n.perimetre-region:last-child {\n  border-bottom: none;\n}\n\n.perimetre-region--full {\n  background: #fff7ed;\n}\n\n.perimetre-region-row {\n  display: flex;\n  align-items: center;\n  gap: 1rem;\n  padding: 0.85rem 1rem;\n}\n\n.perimetre-region-check {\n  display: flex;\n  align-items: center;\n  gap: 0.75rem;\n  flex: 1;\n  cursor: pointer;\n}\n\n.perimetre-region-check input[type=\"checkbox\"] {\n  width: 1.7rem;\n  height: 1.7rem;\n  accent-color: #f97316;\n  flex-shrink: 0;\n}\n\n.perimetre-region-nom {\n  font-weight: 600;\n  color: #374151;\n}\n\n.perimetre-region-count {\n  font-size: 1.2rem;\n  color: #6b7280;\n  white-space: nowrap;\n}\n\n.perimetre-region--full .perimetre-region-count,\n.perimetre-region--partial .perimetre-region-count {\n  color: #f97316;\n  font-weight: 600;\n}\n\n.perimetre-region-toggle {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 2.8rem;\n  height: 2.8rem;\n  border: none;\n  background: none;\n  color: #6b7280;\n  cursor: pointer;\n  border-radius: 0.5rem;\n  flex-shrink: 0;\n}\n\n.perimetre-region-toggle:hover {\n  background: #f3f4f6;\n  color: #374151;\n}\n\n.perimetre-region-toggle svg {\n  transition: transform 0.2s;\n}\n\n.perimetre-region-toggle.is-open svg {\n  transform: rotate(180deg);\n}\n\n/* Liste des departements (depliee) */\n.perimetre-dept-list {\n  list-style: none;\n  margin: 0;\n  padding: 0.25rem 1rem 0.85rem 3.5rem;\n  display: grid;\n  grid-template-columns: repeat(auto-fill, minmax(220px, 1fr));\n  gap: 0.4rem 1.5rem;\n  background: #fafafa;\n}\n\n.perimetre-dept-check {\n  display: flex;\n  align-items: center;\n  gap: 0.6rem;\n  cursor: pointer;\n  padding: 0.3rem 0;\n  font-size: 1.3rem;\n}\n\n.perimetre-dept-check input[type=\"checkbox\"] {\n  width: 1.5rem;\n  height: 1.5rem;\n  accent-color: #f97316;\n  flex-shrink: 0;\n}\n\n.perimetre-dept-code {\n  font-variant-numeric: tabular-nums;\n  color: #111827;\n  font-weight: 600;\n}\n\n.perimetre-dept-nom {\n  color: #374151;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
